export const safeParseURL = (url: string, base?: string) => {
  try {
    return new URL(url, base);
  } catch (err) {
    // We'll just return undefined if the URL doesn't parse
  }
};
